<ng-template #paygateModal let-modal >
    <div class="modal-body">
        <iframe class="paygatepayreceiver" name="paygatepayreceiver" id="paygatepayreceiver" frameBorder="0" scrolling="yes" width="100%" height="900px"></iframe>
    </div>
</ng-template>
